module.exports = __webpack_public_path__ + "static/media/checked.dded611d.svg";